import { Injectable } from '@angular/core';
import { BdbRequestService } from '../../shared/bdb-request.service';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { CifinConfrontaQuestion } from '../models/cifin-confronta-question';
import { environment } from '../../../../environments/environment';
import { ResponseFromFetch } from '../../models/response-from-fetch.model';
import { SessionStorageKeysEnum } from '../../models/session-storage-keys-enum';
import { ChannelService } from '../../shared/channel.service';


@Injectable()
export class BdbCifinConfrontaService {

    private readonly CIFIN_PATH = '/authentication/cifin/authentication-questions';
    private readonly getCifinConfrontaQuestionsURL = `${environment.authenticatorEndpointSandbox}${this.CIFIN_PATH}`;
    private readonly checkCifinConfrontaAnswersURL = `${environment.cifinEndpoint}/check-answers`;

    constructor(
        private readonly bdbRequest: BdbRequestService,
        private readonly bdbSessionStorageService: BdbSessionStrgService,
        private readonly channelService: ChannelService
    ) {
    }


    public getQuestions(): Promise<CifinConfrontaQuestion[]> {
        const currentAttemptsConfronta = +this.bdbSessionStorageService.get(SessionStorageKeysEnum.CURRENT_CONFRONTA_ATTEMPT) + 1;
        const uuidAuth = this.bdbSessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH);
        const dataRequest = {
            body: {
                identityType: this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE),
                identityNumber: this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER),
                uuid: this.bdbSessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH),
                branch: this.bdbSessionStorageService.get(SessionStorageKeysEnum.BRANCH),
                specificProductInfoUuid: this.bdbSessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID),
                currentAttemptsConfronta: String(currentAttemptsConfronta),
                includesSpoofingHardValidationStep: 'false'
            },
            headers: {
                product: this.bdbSessionStorageService.get(SessionStorageKeysEnum.PRODUCT)
            }
        };
        return new Promise<CifinConfrontaQuestion[]>((resolve, reject) => {
            this.bdbRequest.requestPostSandboxOldHeaders(this.getCifinConfrontaQuestionsURL, uuidAuth, dataRequest)
                .then((response: ResponseFromFetch) => {
                    if (response.status === 200) {
                        const bodyResponseAsJson = JSON.parse(response.body);
                        resolve(bodyResponseAsJson);
                    } else {
                        reject(response.body);
                    }
                })
                .catch((reason: any) => {
                    reject(reason);
                });

        });
    }

    public checkAnswers(questionnaire: CifinConfrontaQuestion[]): Promise<ResponseFromFetch> {
        const currentAttemptsConfronta = +this.bdbSessionStorageService.get(SessionStorageKeysEnum.CURRENT_CONFRONTA_ATTEMPT) + 1;
        const body = {
            typeIdentification: this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE),
            numberIdentification: this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER),
            keyAuthenticatedCellPhone: this.bdbSessionStorageService.get(SessionStorageKeysEnum.KEY_AUTHENTICATED_CELLPHONE),
            listConfrontaResponseDto: questionnaire,
            cellphone: this.bdbSessionStorageService.get(SessionStorageKeysEnum.CELL_PHONE),
            sessionIdTM: this.bdbSessionStorageService.get(SessionStorageKeysEnum.SESSION_ID_TM),
            uuidAuth: this.bdbSessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH),
            branch: this.bdbSessionStorageService.get(SessionStorageKeysEnum.BRANCH),
            specificProductInfoUuid: this.bdbSessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID),
            currentAttemptsConfronta: String(currentAttemptsConfronta)
        };
        const headers = {
            product: this.bdbSessionStorageService.get(SessionStorageKeysEnum.PRODUCT),
            channel: this.channelService.getChannel()
        };
        const info = {
            body,
            headers
        };
        return this.bdbRequest.requestPostHeadersEncrypt(this.checkCifinConfrontaAnswersURL, info);
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-cifin-confronta/services/bdb-cifin-confronta.service.ts